import createCache from "@emotion/cache"

const isBrowser = typeof document !== "undefined"

// A dedicated emotion cache for MUI with a stable insertion point.
// Anchoring every emotion <style> tag to a fixed <meta> near the top of
// <head> keeps insertion order deterministic and isolates MUI's styles from
// react-helmet's churn at the end of <head>. Without this, a style tag that
// emotion tracks as its insertion anchor can be removed out from under it,
// producing the production-only `insertBefore` NotFoundError white screen.
export default function createEmotionCache() {
  let insertionPoint

  if (isBrowser) {
    insertionPoint =
      document.querySelector('meta[name="emotion-insertion-point"]') || undefined
  }

  return createCache({ key: "mui", insertionPoint })
}
